import React from 'react'

import * as S from '../styles'

interface InvalidCardNumberProps {
  cardNumber: string
}

export const InvalidCardNumber = ({ cardNumber }: InvalidCardNumberProps): JSX.Element => {
  return (
    <>
      <S.StyledErrorIcon />
      <S.Title >
        Não conseguimos validar sua carteirinha de número {cardNumber}
      </S.Title>
      <S.Text variant='content2'>
        Verifique se ela está correta e entre em contato com a nossa equipe de atendimento pelo chat.
      </S.Text>
    </>
  )
}